import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { TradePhaseEnum } from "../enum/TradePhaseEnum";
import { TradeStatusEnum } from "../enum/TradeStatusEnum";
import { ITrade } from "../interface/trade/ITrade";
import ITradeApprovalPhaseLog from "../interface/trade/ITradeApprovalPhaseLog";
import { IRequestSignaturePending } from "../interface/trade/IRequestSignaturePending";
import { IDefaultTimeSchedule } from "../interface/common/IDefaultTimeSchedule";

enum TradeServiceEnum {
  getAll = "/",
  getById = "/",
  getTradesOpenFromMonitoring = "/get-trades-open-from-monitoring",
  getTradesOpenFromMonitoringDetails = "/get-trades-open-from-monitoring-details?",

  getTradeBCheckByStatusAndPhase = "/get-trades-bcheck-by-phase?",
  updatePendencies = "/update-pendencies",
  specialSituationApprovalLimit = "/get-trades-special-situation-approval-limit-by-current-user",
  createFromWorkflowWithPricing = "/create-trade-from-workflow-with-pricing",
  filterByDateRangeAndUserType = "/filter-by-date-range-and-user-type-dashboard",
  getTradeTrackHistory = "/get-trade-track-history?id=",
  requestSignaturePending = "/request-pending-signature",
  getDefaultTimeSchedule = "/get-default-time-schedule"
}

const createParams = (status: TradeStatusEnum[], phases: TradePhaseEnum[]): string => {
  const paramList = [];
  let params = "";
  status.forEach(value => {
    paramList.push(`Status=${TradeStatusEnum[value]}`);
  });
  phases.forEach(value => {
    paramList.push(`Phase=${value}`);
  });
  paramList.forEach((value, index) => {
    params += index === 0 ? value : "&" + value;
  });
  return params;
};

export default class TradeService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/trade");
  }

  public async getAll() {
    const response: ITrade[] = await this.GET(TradeServiceEnum.getAll);
    return response;
  }

  public getById = async (id): Promise<ITrade> => await this.GET(TradeServiceEnum.getById + id);
  public getOpenFromMonitoring = async (): Promise<ITrade[]> => await this.GET(TradeServiceEnum.getTradesOpenFromMonitoring);
  public getOpenFromMonitoringDetails = async (phase, start, end): Promise<ITrade[]> =>
    await this.GET(TradeServiceEnum.getTradesOpenFromMonitoringDetails + `phase=${phase}&rangeStart=${start}&rangeEnd=${end}`);

  public getTradeBCheckByStatusAndPhase = async (status: TradeStatusEnum[], phases: TradePhaseEnum[]): Promise<ITrade[]> =>
    await this.GET(TradeServiceEnum.getTradeBCheckByStatusAndPhase + createParams(status, phases));


  public getSpecialSituationApprovalLimitByCurrentUser = async () => await this.GET(TradeServiceEnum.specialSituationApprovalLimit);

  public getTradeTrackHistory = async (tradeId: number): Promise<ITradeApprovalPhaseLog[]> => await this.GET(TradeServiceEnum.getTradeTrackHistory + tradeId);

  public requestSignaturePending = async (requestSignaturePending: IRequestSignaturePending) => await this.POST(TradeServiceEnum.requestSignaturePending, requestSignaturePending);

  public getDefaultTimeSchedule = async (): Promise<IDefaultTimeSchedule> => await this.GET(TradeServiceEnum.getDefaultTimeSchedule);
}



// WEBPACK FOOTER //
// ./src/services/api/Trade.service.ts